module.exports = __webpack_public_path__ + "img/sun-haze.2a444f5d.svg";